<template>
<div v-if="contentItem && contentItem.paths">
    <!-- Voltar conteudo da aula -->
    <div
        v-if="previousContent.url"
        @click="navigate('previous')"
        @mouseover="showLeft = true"
        @mouseleave="showLeft = false"
        class="navigation left"
    >
        <i class="navigation-icon fas fa-chevron-left"/>
    </div>

    <!-- Avançar conteúdo da aula -->
    <div
        v-if="nextContent.url"
        @click="navigate('next')"
        @mouseenter="showRight = true"
        @mouseleave="showRight = false"
        class="navigation right"
    >
        <i class="navigation-icon fas fa-chevron-right"/>
    </div>

    <!-- Nomes -->
    <FadeTransition v-if="previousContent">
        <div v-show="showLeft" class="navigation label label-left">
            {{previousContent.translation}}
        </div>
    </FadeTransition>

    <FadeTransition v-if="nextContent">
        <div v-show="showRight" class="navigation label label-right">
            {{nextContent.translation}}
        </div>
    </FadeTransition>
</div>
</template>

<script>
import { FadeTransition } from 'vue2-transitions';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
    name: 'ClassNavigationButtons',

    components: {
        FadeTransition,
    },

    data() {
        return {
            loadedLinks: false,
            showLeft: false,
            showRight: false,
            nextContent: null,
            previousContent: null,
        };
    },
    computed: {
        ...mapGetters({
            content: 'CLASS_CONTENT',
            contentItem: 'CLASS_CONTENT_ITEM',
            contentArray: 'CLASS_CONTENT_ARRAY',
            contentIndex: 'CLASS_CONTENT_INDEX',
            actualLesson: 'CLASS_LESSON',
            menuItems: 'CLASS_MENU_ITEMS',
            language: 'LANGUAGE',
        }),
    },
    methods: {
        ...mapActions({ loadContent: 'CLASS_LOAD_CONTENT' }),
        ...mapMutations({ setLink: 'SET_CLASS_CONTENT_LINK' }),

        iconClass(direction) {
            const icon = `fa-chevron-${direction}`;
            return `navigation-icon fas ${!this.loadedLinks ? icon : 'fa-spinner fa-spin'}`;
        },

        loadNext() {
            const isLast = this.contentIndex + 1 === this.contentArray.length;
            const isFromLesson = this.contentItem.parents.some(p => p.type === 'lesson');

            if (isLast) {
                this.nextContent = null;
                return;
            }
            if (!isFromLesson) {
                this.nextContent = this.contentItem.paths.next;
                return;
            }

            const nextItem = this.contentArray[this.contentIndex + 1];

            if (nextItem.final && this.actualLesson.progress === 100) {
                this.nextContent = this.contentItem.paths.next;
            } else if (nextItem.final) {
                for (let i = this.contentIndex + 1; i < this.contentArray.length; i += 1) {
                    if (!this.contentArray[i].final) {
                        const nextContent = {
                            translation: this.contentArray[i].translation.name,
                            url: this.contentArray[i-1].paths.next,
                        };
                        this.nextContent = nextContent;
                        break;
                    }
                }
            } else {
                this.nextContent = this.contentItem.paths.next;
            }
        },

        loadPrevious() {
            const isFirst = this.contentIndex === 0;
            if (isFirst) {
                this.previousContent = null;
                return;
            }

            const previousItem = this.contentArray[this.contentIndex - 1];

            if (previousItem.final) {
                for (let i = this.contentIndex - 1; i >= 0; i -= 1) {
                    if (!this.contentArray[i].final) {
                        const prevContent = {
                            translation: this.contentArray[i].translation.name,
                            url: this.contentArray[i].paths.current,
                        };
                        this.previousContent = prevContent;
                        break;
                    }
                }
            } else {
                this.previousContent = this.contentItem.paths.previous;
            }
        },

        async navigate(direction) {

            let url = this.nextContent.url;

            if (direction === 'previous') {
                url = this.previousContent.url;
                this.showLeft = false;
            } else {
                this.showRight = false;
            }

            this.setLink(url);
            await this.loadContent({ iso: this.language.iso });
        },

    },
    watch: {
        contentIndex() {
            if (this.contentItem.parents) {
                this.loadNext();
                this.loadPrevious();
            }
        },
        actualLesson() {
            if (this.contentItem.parents) {
                this.loadNext();
                this.loadPrevious();
            }
        },
    },
};
</script>

<style lang="sass">

@mixin navigation
    position: absolute
    top: calc(50vh - 50px)
    opacity: .8
    z-index: 1
    display: inline-block
    background-color: rgba(41, 48, 59, 0.7)
    border: none
    pointer-events: auto
    padding: 13px 8px 8px 8px
    cursor: pointer
    transition: all .2s

.navigation
    @include navigation

.label
    @include navigation
    opacity: 1

.navigation:hover
    opacity: 1

.navigation > i
    color: #fff
    background-color: transparent
    font-size: 20px
    vertical-align: 0

</style>
